import { Container } from '@/components/Container'
import { Loading } from '@/components/Loading'
import { Section } from '@/components/Section'
import { useLogout } from 'BrokerTsLib/src/hooks/useAccount'
import { useEffect } from 'react'

const LogoutPage = () => {
  const { logout, isLoggingOut } = useLogout()

  useEffect(() => {
    if (isLoggingOut) return
    logout()
  }, [logout, isLoggingOut])

  return (
      <Section variant="login">
        <Container>
          <Loading large text='Odhlašování...' /></Container>
      </Section>
  )
}

export default LogoutPage